import axios from './index'
import prefix_ms from './prefix'



/** 是否已投过票 */
export const whetherVoted = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleVote/whetherVoted`,
    method: 'post',
    data: params,
  })
}

/** 用户投票 */
export const userVote = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleVote/vote`,
    method: 'post',
    data: params,
  })
}

/** 获取投票结果 */
export const userVoteResult = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleVote/result`,
    method: 'get',
    params: params,
  })
}

/** 获取投票分享Id */
export const userVoteShareGetInfo = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleVote/share/getInfo`,
    method: 'post',
    data: params,
  })
}

/** 获取投票分享页面内容 */
export const userVoteShareGetContent = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleVote/share/content`,
    method: 'get',
    params: params,
  })
}



//////////////////
// WEBPACK FOOTER
// ./app/api/vote.js
// module id = null
// module chunks = 